import { FC, useState } from 'react';

import CKEditor from 'modules/_shared/components/CKEditor';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const BodySection: FC = () => {
  const { data, actions } = useSendCommunicationModal();

  const [editorInstance, setEditorInstance] = useState<any>(null);

  const handleChangeEditorInstance = (instance: any) => {
    setEditorInstance(instance);
  };

  const handleContentChange = () => {
    if (editorInstance) {
      const newContent = editorInstance.getData();
      if (newContent !== data.body) {
        actions.handleChangeBody(newContent);
      }
    }
  };

  return (
    <div className="nk-reply-form-field p-0 send-email-editor mt-3">
      <CKEditor
        documentModel={data.body || ''}
        documentName="email"
        editorInstance={editorInstance}
        enableMentions={false}
        isCompactVersion
        isEmailVersion
        onChangeContent={handleContentChange}
        setEditorInstance={handleChangeEditorInstance}
      />
    </div>
  );
};

export default BodySection;
